import type { SpecificationStreamContent, SpecificationStreamProvider } from '../types/specification';
import type { SpecificationConfirmClaimsPayload, SpecificationConfirmClaimTree } from '../types/specification-confirm-claims';

export const SpecificationConfirmClaimsRepository = Symbol.for('SpecificationConfirmClaimsRepository');

export interface SpecificationConfirmClaimsRepository {
    /** 格式化权利要求 */
    genFormattedClaim(taskId: string): SpecificationStreamProvider<SpecificationStreamContent<string>>;

    /** 生成权利要求树 */
    genClaimTree(taskId: string, regenerate?: boolean): SpecificationStreamProvider<SpecificationStreamContent<SpecificationConfirmClaimTree>>;

    /**
     * 提交
     */
    submit(taskId: string, payload: SpecificationConfirmClaimsPayload): Promise<void>;
}
